<template>
  <el-pagination
    v-if="pagisShow"
    class="fixed"
    @current-change="$emit('currentChange', $event)"
    :current-page="pageNo"
    background
    :page-size="pageSize"
    layout="total,prev, pager, next"
    :total="total"
  >
  </el-pagination>
</template>

<script>
export default {
  name: "Pagiation",
  props: {
    // 页码
    pageNo: {
      type: Number,
      default: 1,
    },
    // 每页数量
    pageSize: {
      type: Number,
      default: 20,
    },
    // 总条数
    total: {
      type: Number,
      default: 0,
    },
    // 是否显示分页
    pagisShow: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.fixed {
  position: relative;
  text-align: center;
  padding: 50px 0;
}
</style>
